// extracted by mini-css-extract-plugin
export default {"card":"Card_card__-SwHU","title":"Card_title__A6GVy","subtitle":"Card_subtitle__-vcTL","img":"Card_img__8Ehvv"};